import type { MenuCategory, MenuItem } from '../../api/types'
import { ItemCard } from './ItemCard'

interface Props {
  category: MenuCategory
  onItemTap: (item: MenuItem) => void
}

export function CategorySection({ category, onItemTap }: Props) {
  const available = category.items.filter((item) => item.is_available)

  return (
    <section id={`category-${category.id}`} aria-labelledby={`category-heading-${category.id}`}>
      <h2
        id={`category-heading-${category.id}`}
        className="px-4 pt-6 pb-2 text-base font-bold font-heading text-neutral-800"
      >
        {category.name}
      </h2>
      {available.length > 0 ? (
        <ul className="grid grid-cols-1 gap-4 px-4 py-2">
          {available.map((item) => (
            <li key={item.id}>
              <ItemCard item={item} onTap={onItemTap} />
            </li>
          ))}
        </ul>
      ) : (
        <p className="px-4 py-3 text-sm text-neutral-400">
          No items available in this category.
        </p>
      )}
    </section>
  )
}
